module.exports = __webpack_public_path__ + "static/media/fr_preview.808d9d93.jpg";